module.exports = __webpack_public_path__ + "media/directory/comment_icon-f9e7ebb5.svg";